import { firstOklahomaColor } from "@assets/images";
import { PartnerLogoProps } from "@ctypes";
import { resolveLogoSize } from "@utils/logo";

const WIDTH = 82;
const HEIGHT = 38;

export const FirstOklahomaLogoColor = ({ className, style, width, height }: PartnerLogoProps) => {
  const size = resolveLogoSize({ width, height, naturalWidth: WIDTH, naturalHeight: HEIGHT });

  return (
    <img
      src={firstOklahomaColor}
      alt=""
      className={className}
      style={{ ...size, objectFit: "contain", ...style }}
    />
  );
};
